import React, { Component } from 'react';

import { Card } from 'material-ui/Card';
import DetailView from '../Common/DetailView';

const actions = [];

class ErrorLog extends Component {

    render() {

        return (
            <DetailView
                title="Logs - error"
                backButton={true}
                backTo="/dashboard"
                actions={actions}
            >
                <div className='cent-cards'>
                    <Card className="cent-card">

                    </Card>
                </div>
            </DetailView>
        )
    }
}

export default ErrorLog;
